export default __webpack_public_path__ + "static/media/bay.3c407fb1.svg";